/**
 * Creation time of an API item: its `createdAt`, or else the time encoded in
 * its MongoDB id (first 8 hex digits, in seconds). NaN when unknown.
 */
export const createdTime = (item) => {
  const time = new Date(item?.createdAt).getTime();
  if (!Number.isNaN(time)) return time;
  return /^[0-9a-f]{24}$/i.test(item?._id || "")
    ? parseInt(item._id.slice(0, 8), 16) * 1000
    : NaN;
};

/**
 * Sorts (in place) by creation time, newest first. Items with the same (or
 * no) date keep their order.
 */
export const newestFirst = (list) =>
  list?.sort((a, b) => createdTime(b) - createdTime(a) || 0);

/** Plain text of an HTML snippet (rich text descriptions). */
export const stripHtml = (html) => (html || "").replace(/(<([^>]+)>)/gi, "");

export const capitalize = (text) =>
  text ? text.charAt(0).toUpperCase() + text.slice(1) : text;

/** Case-insensitive "contains" on a possibly missing string. */
export const matches = (text, query) =>
  (text || "").toLowerCase().includes(query.trim().toLowerCase());
